export type BenefitIcon = 'ShieldCheck' | 'PercentCircle' | 'PackageCheck';

export type BenefitItem = {
  id: string;
  label: string;
  icon: BenefitIcon;
  description: string;
};

export const BENEFIT_DETAILS: BenefitItem[] = [
  {
    id: 'authenticity',
    label: '100% Authenticity Guarantee',
    icon: 'ShieldCheck',
    description:
      'We want you to feel reassured when purchasing your skincare products on SkinSeoul, so we offer an authentic product guarantee for all orders. We ship all orders direct from our warehouse in Korea and we guarantee that we will refund your order in full if you believe your product is inauthentic. If you are concerned about the authenticity of your product, please send us an email and our team will be able to assist.',
  },
  {
    id: 'pricing',
    label: 'Lowest Pricing Policy',
    icon: 'PercentCircle',
    description:
      'We partner directly with Korean manufacturers and maintain an efficient supply chain to ensure you receive authentic Korean skincare at the best possible value. If you find the same authentic product at a lower price from a competitor, we offer a Price Match Guarantee. Please note, we can only price match against regular, non-promotional pricing.',
  },
  {
    id: 'return',
    label: 'Return + Exchange Policy',
    icon: 'PackageCheck',
    description: `• Damaged/Faulty Products: If your order arrives damaged or faulty, please reach out to us within 5 days. You can choose between a replacement (with return shipping refunded) or a full refund (including return shipping).

• Hazardous Items (e.g., broken bottles): Simply provide us with a photo or video of the item, and we'll process your refund or exchange—no need to return the product.

• Change of Mind Returns: If you've had a change of heart, we accept returns within 7 days, as long as the product is unopened & unused. Return shipping costs will be covered by the customer, and refunds will be issued after inspection.

• Refund Processing Time: Credit card: 7-14 working days, PayPal: 3-5 working days.

• Missing Items: If anything is missing from your order, please contact our support team with your order details & photos, and we'll make sure to send the missing items to you as soon as possible.

For assistance, email support@skin-seoul.com – we're here to help!`,
  },
  {
    id: 'customs-taxes-policy',
    label: 'Customs + Taxes Policy',
    icon: 'PackageCheck',
    description: `Getting the latest and freshest skincare products from Korea with SkinSeoul means that we ship directly from Korea itself. Therefore your items do pass through customs in the destination country and, whilst rare, you may be charged customs and taxes, or other fees, according to local regulations. As we are shipping via our logistics partner, they may also charge a brokerage fee for handling the process and fees on our behalf.

• For shipment to the United States, SkinSeoul charges fees to cover customs taxes and import duties as stipulated by US customs regulations, following the suspension of the De Minimis Entry exemption for all shipments, effective August 29, 2025.
• For shipment outside of the United States, SkinSeoul does not take responsibility for the amount charged as this is dependent on the regulations of the destination country, including cases where local custom offices conduct a re-assessment of the parcel value for fee calculation.

Not to worry! Should there be any customs and taxes charges upon delivery, you can claim them directly with us.

Simply make the payment directly to the logistics provider to release the package, keep the receipt, and we will send you SkinSeoul voucher up to the value of your order (excluding shipping fees). To request for this, please email us at support@skin-seoul.com with the following details within 30 days of the payment receipt date:

• Your order number
• A clear copy of the receipt for the fees paid, issued by the logistics provider
• A description of the charges

Refund voucher claims must be submitted in a timely manner, and the evaluation and approval of the claim are at the sole discretion of the company.

If you refuse the package delivery due to customs issues, including refusal to pay customs and brokerage fees, this can cause significant delays should you wish to subsequently make payment to release the package. Unfortunately, SkinSeoul does not offer refunds or reshipments of packages which have been refused by the customer.`,
  },
];

export const US_CUSTOMERS_BENEFITS = [
  { id: 'authenticity', label: '100% Authenticity Guarantee', icon: 'ShieldCheck' },
  { id: 'pricing', label: 'Lowest Pricing Policy', icon: 'PercentCircle' },
  { id: 'return', label: 'Return + Exchange Policy', icon: 'PackageCheck' },
] as const;

export const NON_US_CUSTOMERS_BENEFITS = [
  { id: 'authenticity', label: '100% Authenticity Guarantee', icon: 'ShieldCheck' },
  { id: 'pricing', label: 'Lowest Pricing Policy', icon: 'PercentCircle' },
  { id: 'customs-taxes-policy', label: 'Voucher Refund for Customs + Taxes', icon: 'PackageCheck' },
] as const;

